import { ReactElement, useState } from 'react';
import PropTypes from 'prop-types';
import CssBaseline from '@mui/material/CssBaseline';
import FormLayout from 'layouts/FormLayout';
import HelpLayout from 'layouts/HelpLayout';
import HelpBar, {
	Main,
} from 'pages/ApplicationRequest/components/containers/1616BridgesEpic/components/HelpBar';

/**
 * Display a uniform page layout
 * @param {string} title page title
 * @param {object} help help customization and configuration
 * @param {object} children page component to render
 * @returns {ReactElement} layout to contain the form and the help panel
 */
const ViewLayout = ({ title, help = {}, children }) => {
	const [sOpen, setOpen] = useState(false);
	return (
		<>
			<CssBaseline />
			<Main open={sOpen}>
				<FormLayout title={title} setOpen={() => setOpen(!sOpen)}>
					{children}
				</FormLayout>
			</Main>
			{help?.title && (
				<HelpBar open={sOpen} setOpen={setOpen}>
					<HelpLayout title={help.title}>{help.contents}</HelpLayout>
				</HelpBar>
			)}
		</>
	);
};

ViewLayout.propTypes = {
	title: PropTypes.string.isRequired,
	help: PropTypes.shape({
		title: PropTypes.string,
		contents: PropTypes.element,
	}),
	children: PropTypes.element,
};

export default ViewLayout;
